// extracted by mini-css-extract-plugin
export default {"widget":"Y19y_p","widgetContainer":"vD4suW"};